export const types = {
  GET_VALIDATION_PIN_BEGINS: 'PIN_VALIDATION/GET_VALIDATION_PIN_BEGINS',
  GET_VALIDATION_PIN_SUCCESS: 'PIN_VALIDATION/GET_VALIDATION_PIN_SUCCESS',
  GET_VALIDATION_PIN_FAIL: 'PIN_VALIDATION/GET_VALIDATION_PIN_FAIL',
  GET_VALIDATION_PIN_RESET: 'PIN_VALIDATION/GET_VALIDATION_PIN_RESET',
  VALIDATE_VALIDATION_PIN_BEGINS:
    'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_BEGINS',
  VALIDATE_VALIDATION_PIN_SUCCESS:
    'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_SUCCESS',
  VALIDATE_VALIDATION_PIN_FAIL: 'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_FAIL',
  VALIDATE_VALIDATION_PIN_RESET: 'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_RESET',
  VALIDATE_VALIDATION_PIN_INVALID_PIN_FAIL:
    'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_INVALID_PIN_FAIL',
  VALIDATE_VALIDATION_PIN_MAX_RETRIES_FAIL:
    'PIN_VALIDATION/VALIDATE_VALIDATION_PIN_MAX_RETRIES_FAIL',
};

export const initialState = {
  getPinFail: false,
  getPinInfo: {},
  getPinInit: false,
  getPinSuccess: false,
  validatePinFail: false,
  validatePinMaxRetriesFail: false,
  validatePinInfo: {},
  validatePinInit: false,
  validatePinSuccess: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const PinReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_VALIDATION_PIN_BEGINS:
      return {
        ...state,
        getPinInit: true,
        getPinSuccess: false,
        getPinFail: false,
      };
    case types.GET_VALIDATION_PIN_SUCCESS:
      return {
        ...state,
        getPinInit: false,
        getPinSuccess: true,
        getPinFail: false,
        getPinInfo: {
          ...state.getPinInfo,
          [action.payload.portabilityComponentId]: {
            pinRequestId: action.payload.data.pinRequestId,
            phoneNumber: action.payload.phoneNumber,
          },
        },
      };
    case types.GET_VALIDATION_PIN_FAIL:
      return {
        ...state,
        getPinInit: false,
        getPinSuccess: false,
        getPinFail: true,
      };
    case types.GET_VALIDATION_PIN_RESET:
      if (state.getPinInfo[action.portabilityComponentId]) {
        const newState = {...state};
        delete newState.getPinInfo[action.portabilityComponentId];
        return {
          ...newState,
          getPinInit: false,
          getPinSuccess: false,
          getPinFail: false,
        };
      }
      return {
        ...state,
      };
    case types.VALIDATE_VALIDATION_PIN_BEGINS:
      return {
        ...state,
        validatePinInit: true,
        validatePinSuccess: false,
        validatePinFail: false,
        validatePinMaxRetriesFail: false,
      };
    case types.VALIDATE_VALIDATION_PIN_SUCCESS:
      return {
        ...state,
        validatePinInit: false,
        validatePinSuccess: true,
        validatePinFail: false,
        validatePinMaxRetriesFail: false,
        validatePinInfo: {
          ...state.validatePinInfo,
          [action.portabilityComponentId]: true,
        },
      };
    case types.VALIDATE_VALIDATION_PIN_FAIL:
      return {
        ...state,
        validatePinInit: false,
        validatePinSuccess: false,
        validatePinFail: true,
        validatePinMaxRetriesFail: false,
      };
    case types.VALIDATE_VALIDATION_PIN_INVALID_PIN_FAIL:
      return {
        ...state,
        validatePinInit: false,
        validatePinSuccess: false,
        validatePinFail: true,
        validatePinMaxRetriesFail: false,
        validatePinInfo:{
          ...state.validatePinInfo,
          [action.portabilityComponentId]: false,
        }
      };
    case types.VALIDATE_VALIDATION_PIN_MAX_RETRIES_FAIL:
      return {
        ...state,
        validatePinInit: false,
        validatePinSuccess: false,
        validatePinFail: true,
        validatePinMaxRetriesFail: true,
        validatePinInfo:{
          ...state.validatePinInfo,
          [action.portabilityComponentId]: false,
        }
      };
    case types.VALIDATE_VALIDATION_PIN_RESET:
      if (state.validatePinInfo[action.portabilityComponentId]) {
        const newState = {...state};
        delete newState.validatePinInfo[action.portabilityComponentId];
        return {
          ...newState,
          validatePinInit: false,
          validatePinSuccess: false,
          validatePinFail: false,
          validatePinMaxRetriesFail: false,
        };
      }
      return {
        ...state,
      };
    default:
      return state;
  }
};

export const actions = {
  getPin: (phoneNumber, portabilityComponentId) => ({
    type: types.GET_VALIDATION_PIN_BEGINS,
    phoneNumber,
    portabilityComponentId,
  }),
  getPinSuccess: (phoneNumber, portabilityComponentId, data) => ({
    type: types.GET_VALIDATION_PIN_SUCCESS,
    payload: { phoneNumber, portabilityComponentId, data },
  }),
  getPinFail: () => ({ type: types.GET_VALIDATION_PIN_FAIL }),
  getPinReset: portabilityComponentId => ({
    type: types.GET_VALIDATION_PIN_RESET,
    portabilityComponentId,
  }),
  validatePin: (
    phoneNumber,
    pinNumber,
    pinRequestId,
    portabilityComponentId,
  ) => ({
    type: types.VALIDATE_VALIDATION_PIN_BEGINS,
    phoneNumber,
    pinNumber,
    pinRequestId,
    portabilityComponentId,
  }),
  validatePinSuccess: portabilityComponentId => ({
    type: types.VALIDATE_VALIDATION_PIN_SUCCESS,
    portabilityComponentId,
  }),
  validatePinFail: () => ({
    type: types.VALIDATE_VALIDATION_PIN_FAIL,
  }),
  validatePinInvalidPinFail: portabilityComponentId => ({
    type: types.VALIDATE_VALIDATION_PIN_INVALID_PIN_FAIL,
    portabilityComponentId,
  }),
  validatePinMaxRetriesFail: portabilityComponentId => ({
    type: types.VALIDATE_VALIDATION_PIN_MAX_RETRIES_FAIL,
    portabilityComponentId,
  }),
  validatePinReset: portabilityComponentId => ({
    type: types.VALIDATE_VALIDATION_PIN_RESET,
    portabilityComponentId,
  }),
};

export default PinReducer;
